/** Latest board tasks, so a card that skipped re-render can still list a new mission. */
export const boardTasksLive = { current: null };
